import { FC } from 'react';

/** @deprecated */
const SummaryIcon: FC = () => (
  <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0469 17.885V23.885H1.04688V2.88501H22.0469V17.885H16.0469V17.885Z"
      stroke="black"
      strokeLinejoin="round"
    />
    <path d="M22.0469 17.885L16.0469 23.885" stroke="black" strokeLinejoin="round" />
    <path
      d="M4.04688 0.88501V5.38501"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.04688 0.88501V5.38501"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0469 0.88501V5.38501"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0469 0.88501V5.38501"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.04688 7.88501L6.04688 10.885L4.54688 9.38501"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.04688 13.385L6.04688 16.385L4.54688 14.885"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0469 9.88501H17.5469"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.0469 14.885H17.5469" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SummaryIcon;
